export function loadListFilters(key) {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || '{}');
    return value && typeof value === 'object' && !Array.isArray(value)
      ? value
      : {};
  } catch {
    return {};
  }
}

export function saveListFilters(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Filters are optional UI state.
  }
}

export function clearListFilters() {
  try {
    ['deposits_filters', 'withdraws_filters', 'wallets_filters'].forEach(
      (key) => sessionStorage.removeItem(key),
    );
  } catch {
    // Filters are optional UI state.
  }
}

export function restoreDateRange(value) {
  if (!Array.isArray(value) || value.length !== 2) {
    return '';
  }
  const dates = value.map((date) => new Date(date));
  return dates.every((date) => !Number.isNaN(date.getTime())) ? dates : '';
}
